
export const services = [
  {
    id: 'glass-replacement',
    title: 'Заміна автоскла',
    description: 'Професійна заміна лобового, бокового та заднього скла з гарантією якості. Використовуємо оригінальне та сертифіковане скло.',
    icon: 'Windshield',
    detailedDescription: 'Заміна автоскла – це складна процедура, яка вимагає професійного підходу та якісних матеріалів. Наші фахівці мають багаторічний досвід роботи з усіма марками автомобілів. Ми використовуємо тільки оригінальне або сертифіковане скло від перевірених виробників. Процес заміни включає демонтаж старого скла, підготовку поверхні, нанесення спеціального клею та встановлення нового скла з дотриманням усіх технологічних норм. Гарантуємо герметичність та безпеку.',
    benefits: [
      'Оригінальне та сертифіковане скло',
      'Гарантія на роботу та матеріали',
      'Досвідчені майстри',
      'Швидке виконання робіт'
    ],
    pricing: 'Вартість залежить від марки та моделі автомобіля. Безкоштовна консультація та розрахунок вартості за телефоном.'
  },
  {
    id: 'window-tinting',
    title: 'Тонування вікон',
    description: 'Професійне тонування автомобільних стекол якісною плівкою. Різні рівні затемнення на вибір.',
    icon: 'Sun',
    detailedDescription: 'Тонування автомобільних стекол – це не тільки естетика, але й захист від сонячних променів, підвищення приватності та безпеки. Ми використовуємо тільки якісну тонувальну плівку від перевірених виробників. Пропонуємо різні рівні затемнення відповідно до законодавства України. Наші майстри акуратно наносять плівку без бульбашок та складок. Гарантуємо довговічність та якість тонування.',
    benefits: [
      'Якісна тонувальна плівка',
      'Різні рівні затемнення',
      'Відповідність законодавству',
      'Гарантія на роботу'
    ],
    pricing: 'Вартість залежить від типу плівки та кількості стекол. Безкоштовна консультація.'
  },
  {
    id: 'glass-sale',
    title: 'Продаж автоскла',
    description: 'Продаж оригінального та неоригінального автоскла для всіх марок автомобілів за доступними цінами.',
    icon: 'ShoppingCart',
    detailedDescription: 'У нашому асортименті представлене автоскло для всіх популярних марок та моделей автомобілів. Ми пропонуємо як оригінальне скло від виробників автомобілів, так і якісне неоригінальне скло від перевірених постачальників. Усе скло сертифіковане та має гарантію якості. Можливість замовлення скла під конкретну модель автомобіля. Доставка по Києву та Україні.',
    benefits: [
      'Оригінальне та неоригінальне скло',
      'Сертифікована продукція',
      'Доставка по Києву',
      'Конкурентні ціни'
    ],
    pricing: 'Ціни на скло залежать від марки автомобіля та типу скла. Дзвоніть для уточнення наявності та вартості.'
  },
  {
    id: 'special-equipment-glass',
    title: 'Автоскло для спецтехніки та вантажівок',
    description: 'Спеціалізуємося на заміні та продажу скла для вантажних автомобілів, автобусів, екскаваторів та іншої спецтехніки.',
    icon: 'Truck',
    detailedDescription: 'Робота з вантажним транспортом та спецтехнікою вимагає особливого підходу та спеціального обладнання. Наші майстри мають досвід роботи з вантажівками всіх типів та спеціальною технікою різного призначення. Ми виконуємо заміну скла на екскаваторах, навантажувачах, тракторах, комбайнах. Використовуємо професійне обладнання для безпечного демонтажу та встановлення.',
    benefits: [
      'Досвід роботи з вантажівками та спецтехнікою',
      'Спеціальне обладнання',
      'Скло для всіх типів техніки',
      'Виїзд на об\'єкт'
    ],
    pricing: 'Вартість робіт розраховується індивідуально. Можливий виїзд для оцінки та виконання робіт.'
  }
];
